// Javascript
import "../assets/js/_main";

// Style
import "../assets/scss/main.scss";